import { Stack } from '@mui/material';

import { Button } from 'shared/ui/Button';
import { Text } from 'shared/ui/Text';

import cls from './ErrorPageWidget.module.scss';

const reloadPage = () => window.location.reload();

const buttonStyle = {
  height: '46px',
  textTransform: 'none',
};

export const ErrorPageWidget = () => {
  return (
    <Stack
      display='grid'
      gridTemplateColumns='1fr 1fr'
      height='100vh'
      minHeight='400px'
    >
      <div className={cls.Banner__Container}>
        <div className={cls.Banner__Image} />
      </div>

      <Stack alignItems='center' style={{ padding: '160px 20px' }}>
        <Stack gap='36px' alignItems='center' width='460px'>
          <Stack gap='8px'>
            <Text variant='h2' textAlign='center' fontSize='32px'>
              Ошибка
            </Text>
            <Text
              variant='t1'
              color='var(--ucr-palette-text-grey-400)'
              textAlign='center'
            >
              Мы уже работаем над её устранением. Пожалуйста, попробуйте позже
            </Text>
          </Stack>

          <Button
            variant='contained'
            color='primary'
            onClick={reloadPage}
            style={buttonStyle}
          >
            Перезагрузить страницу
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
